import { ColDef } from 'ag-grid-community';
import { PartnerSearchByBrResponse } from 'pco-product-service-internal-consumer';
import {
  formatEbankingBlocked,
  formatEbankingJNumber,
  formatEbankingLastLogin,
} from '../../../ebankingAttributeFormat';

export const ebankingPartnerSearchColumns: ColDef<PartnerSearchByBrResponse>[] = [
  {
    headerName: 'J-Number',
    field: 'jNr',
    flex: 1,
    filter: 'agTextColumnFilter',
    valueGetter: ({ data }) => formatEbankingJNumber(data?.jNr),
  },
  {
    headerName: 'Blocked',
    flex: 1,
    filter: 'agSetColumnFilter',
    valueGetter: ({ data }) => formatEbankingBlocked(data?.isBlocked),
    filterValueGetter: ({ data }) => formatEbankingBlocked(data?.isBlocked),
  },
  {
    headerName: 'Last login',
    flex: 1,
    filter: 'agTextColumnFilter',
    valueGetter: ({ data }) => formatEbankingLastLogin(data?.lastLogin),
  },
];
